// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  USER_CHANGE_CURRENT_FRUI_PFXH_TYPE_TESTS,
} from './constants';

export function changeCurrentFruiPfxhTypeTests(modal) {
  return {
    type: USER_CHANGE_CURRENT_FRUI_PFXH_TYPE_TESTS,
    data:modal
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_CHANGE_CURRENT_FRUI_PFXH_TYPE_TESTS:
      return {
        ...state,
        currentFrui_pfxhTypeTests:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/changeCurrentFruiPfxhTypeTests.js